<template>
  <div v-if="hasPendingApprovalRequest || canManage" class="flex flex-col space-y-2">
    <ProjectAssetReviewManager
      v-if="hasPendingApprovalRequest"
      :project-asset-id="projectAsset.id"
    />
    <ProjectAssetReviewsManager
      v-if="canManage && hasApprovalRequests"
      :project-asset-id="projectAsset.id"
    />
  </div>
</template>

<script>
import ProjectAssetReviewManager from './projectAssetApprovalManager/ProjectAssetReviewManager.vue';
import ProjectAssetReviewsManager from './projectAssetApprovalManager/ProjectAssetReviewsManager.vue';

export default {
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  computed: {
    project() {
      if (!this.projectAsset?.projectId) {
        return null;
      }

      return this.$store.state.entities.projects.byId[this.projectAsset.projectId];
    },
    hasPendingApprovalRequest() {
      if (!this.projectAsset?.pendingApprovalRequest) {
        return false;
      }

      return true;
    },
    hasApprovalRequests() {
      if (!this.projectAsset.approvalRequestsCount) {
        return false;
      }

      return this.projectAsset.approvalRequestsCount > 0;
    },
    canManage() {
      if (this.$isAdminOrSuperAdmin || this.isProjectManager()) {
        return true;
      }

      return false;
    },
  },
  components: {
    ProjectAssetReviewManager,
    ProjectAssetReviewsManager,
  },
  methods: {
    isProjectManager() {
      if (typeof this.project?.ownerId === 'string' && this.project.ownerId === this.$user.id) {
        return true;
      }

      return false;
    },
  },
};
</script>
